<template>
    <div class="novel-view"
         v-loading="is_loading"
         element-loading-text="loading...">
        <div class="novel-inner">
            <div class="catalog-wrap">
                <ul class="catalog-inner">
                    <li class="catalog-item" v-for="(item, index) in catalog_arr" :key="index">
                        <router-link class="catalog-link" :to="'/novel/201801050944'">第{{index}}章</router-link>
                    </li>
                </ul>
            </div>
            <div class="novel-content-wrap" v-if="$route.meta.catalog">
                <transition enter-active-class="animated fadeIn"
                            leave-active-class="animated fadeOut">
                    <router-view class="novel-content-inner"></router-view>
                </transition>
            </div>
        </div>
    </div>
</template>
<script>
    import API from '../../assets/api'
    export default {
        data () {
            return {
                catalog_arr: 30,
                is_loading: false
            }
        },
        created () {

        },
        methods: {

        }
    }
</script>
<style lang="scss">
    @import '../../assets/scss/define';
    .novel-view{
        background-color: #fff;
    }
    .novel-inner{
        @extend %pa;
        @extend %t0;
        @extend %l0;
        @extend %r0;
        @extend %b0;
        @extend %df;
        @extend %oh;
    }
    .catalog-wrap{
        @extend %df1;
        @extend %pr;
        @extend %oh;
    }
    .catalog-inner{
        @extend %pa;
        @extend %t0;
        @extend %l0;
        @extend %b0;
        right: -16px;
        padding: 20px 0;
        overflow-y: scroll;
    }
    .catalog-item{
        @extend %df;
        justify-content: center;
        align-items: center;
        height: 30px;
    }
    .catalog-link{
        @extend %f14;
        @extend %c3;
    }
    .novel-content-wrap{
        @extend %pr;
        @extend %oh;
        flex: 9;
    }
    .novel-content-inner{
        @extend %pa;
        @extend %t0;
        @extend %l0;
        @extend %b0;
        right: -16px;
        padding: 20px 0;
        overflow-y: scroll;
    }
</style>



// WEBPACK FOOTER //
// src/views/novel/novel.vue